export const selectQuestionsForTest = (allQuestions, config, userHistory = []) => {
  // Verificación inicial
  if (!config || !allQuestions || allQuestions.length === 0) {
    console.log('No hay preguntas o configuración disponible');
    return [];
  }

  // Desestructurar la configuración con valores por defecto
  const {
    numberOfQuestions = 10,
    rotateQuestions = true,
    requireAllDifficulties = false
  } = config;

  console.log(`Configuración: ${numberOfQuestions} preguntas, rotación: ${rotateQuestions}, todas las dificultades: ${requireAllDifficulties}`);

  // Asegurarse de que no pedimos más preguntas de las disponibles
  const actualNumberOfQuestions = Math.min(numberOfQuestions, allQuestions.length);

  // Función para mezclar array
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // Agrupar preguntas por dificultad
  const questionsByDifficulty = {
    basico: allQuestions.filter(q => q.difficulty === 'basico' || !q.difficulty),
    intermedio: allQuestions.filter(q => q.difficulty === 'intermedio'),
    avanzado: allQuestions.filter(q => q.difficulty === 'avanzado')
  };

  let selectedQuestions = [];

  if (requireAllDifficulties) {
    // Asegurar al menos una pregunta de cada dificultad disponible
    const difficulties = ['basico', 'intermedio', 'avanzado'];
    const availableDifficulties = difficulties.filter(diff => 
      questionsByDifficulty[diff].length > 0
    );

    if (availableDifficulties.length === 0) {
      console.log('No hay preguntas con dificultades definidas');
      return shuffleArray(allQuestions).slice(0, actualNumberOfQuestions);
    }

    // Calcular cuántas preguntas por dificultad
    const questionsPerDifficulty = Math.floor(actualNumberOfQuestions / availableDifficulties.length);
    const remainder = actualNumberOfQuestions % availableDifficulties.length;

    availableDifficulties.forEach((difficulty, index) => {
      const questions = questionsByDifficulty[difficulty];
      const numQuestions = questionsPerDifficulty + (index < remainder ? 1 : 0);
      
      if (questions.length > 0) {
        // Mezclar las preguntas de esta dificultad
        const shuffledQuestions = shuffleArray(questions);
        
        // Seleccionar preguntas teniendo en cuenta el historial
        const selectedFromDifficulty = shuffledQuestions
          .sort((a, b) => {
            const aUsed = userHistory.filter(h => h.questionId === a.id).length;
            const bUsed = userHistory.filter(h => h.questionId === b.id).length;
            return aUsed - bUsed;
          })
          .slice(0, numQuestions);

        selectedQuestions.push(...selectedFromDifficulty);
      }
    });

  } else {
    // Si no se requieren todas las dificultades, simplemente mezclar todas las preguntas
    let availableQuestions = [...allQuestions];

    // Filtrar basado en el historial del usuario
    if (userHistory.length > 0) {
      availableQuestions = availableQuestions.sort((a, b) => {
        const aUsed = userHistory.filter(h => h.questionId === a.id).length;
        const bUsed = userHistory.filter(h => h.questionId === b.id).length;
        if (aUsed === bUsed) return Math.random() - 0.5;
        return aUsed - bUsed;
      });
    }

    // Mezclar y seleccionar
    selectedQuestions = shuffleArray(availableQuestions).slice(0, actualNumberOfQuestions);
  }

  // Mezclar una última vez si la rotación está activada
  if (rotateQuestions) {
    selectedQuestions = shuffleArray(selectedQuestions);
  }

  console.log(`Seleccionadas ${selectedQuestions.length} preguntas de ${allQuestions.length} disponibles`);
  
  return selectedQuestions;
};